import { arrayOf, number, func, array, object, string } from "prop-types";
import React from "react";

const TimesheetColumnTotalsRow = ({
  columnTotals,
  columnErrors,
  bookedDays,
  nonAttendanceDays,
  nonAttendanceCodes,
  returnDays,
  dayTypeTotals,
  rowType = "H",
}) => {
  return (
    <tr>
      <td></td>
      {columnTotals.map((sum, i) => (
        <td key={i} align="center">
          {rowType === "H"
            ? returnDays(
                columnErrors[i],
                bookedDays[i],
                nonAttendanceDays[i],
                sum,
                nonAttendanceCodes
              )
            : dayTypeTotals(
                columnErrors[i],
                bookedDays[i],
                nonAttendanceDays[i],
                sum,
                nonAttendanceCodes
              )}
        </td>
      ))}
    </tr>
  );
};

TimesheetColumnTotalsRow.propTypes = {
  columnTotals: arrayOf(number),
  columnErrors: array,
  bookedDays: array,
  nonAttendanceDays: array,
  nonAttendanceCodes: object,
  returnDays: func,
  dayTypeTotals: func,
  rowType: string,
};

export default TimesheetColumnTotalsRow;
